
<div #contentDiv [innerHtml]="content" class="snippet-content"></div>
    

